import React from "react";
import Modal from "react-bootstrap/Modal";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { globalOperations } from "../state/ducs/globalState";
import { numberWithCommas } from "../utils";

function AddToCartModal({ show, close, cartItems, isAuthenticated }) {
  const latestAddedProduct = cartItems.length
    ? cartItems[0]
    : { name: "no items", photo: "test" };

  let subtotalPrice = 0;
  for (let index = 0; index < cartItems.length; index++) {
    const element = cartItems[index];
    subtotalPrice += parseInt(element.price) * element.quantity;
  }

  const styles = {
    modalHeader: {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      border: 'none',
      borderRadius: '15px 15px 0 0',
      padding: '20px 30px'
    },
    modalTitle: {
      fontSize: '20px',
      fontWeight: '600',
      margin: 0,
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },
    successIcon: {
      backgroundColor: 'rgba(255,255,255,0.2)',
      borderRadius: '50%',
      padding: '8px',
      fontSize: '16px'
    },
    modalBody: {
      padding: '30px',
      backgroundColor: '#ffffff'
    },
    productImage: {
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
      transition: 'transform 0.3s ease',
      width: '100%',
      height: '300px',
      objectFit: 'cover'
    },
    productInfo: {
      padding: '20px 0'
    },
    productName: {
      fontSize: '24px',
      fontWeight: '600',
      color: '#2c3e50',
      marginBottom: '15px',
      lineHeight: '1.3'
    },
    priceQuantity: {
      fontSize: '20px',
      fontWeight: '500',
      color: '#6c757d',
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },
    priceSpan: {
      fontSize: '24px',
      fontWeight: '700',
      color: '#e74c3c'
    },
    actionPanel: {
      background: 'linear-gradient(145deg, #f8f9fc 0%, #f1f3f8 100%)',
      padding: '30px 25px',
      borderRadius: '15px',
      border: '1px solid #e9ecef',
      height: 'fit-content',
      boxShadow: '0 4px 15px rgba(0,0,0,0.05)'
    },
    checkoutBtn: {
      background: 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)',
      border: 'none',
      color: 'white',
      padding: '15px 25px',
      borderRadius: '10px',
      fontSize: '16px',
      fontWeight: '600',
      width: '100%',
      marginBottom: '20px',
      textDecoration: 'none',
      display: 'inline-block',
      textAlign: 'center',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 15px rgba(231, 76, 60, 0.3)'
    },
    subtotalSection: {
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '10px',
      margin: '20px 0',
      border: '1px solid #e9ecef',
      textAlign: 'center'
    },
    subtotalLabel: {
      fontSize: '14px',
      color: '#6c757d',
      marginBottom: '10px',
      textTransform: 'uppercase',
      letterSpacing: '0.5px'
    },
    subtotalPrice: {
      fontSize: '28px',
      fontWeight: '700',
      color: '#2c3e50',
      display: 'block',
      marginBottom: '10px'
    },
    cartInfo: {
      fontSize: '13px',
      color: '#95a5a6',
      fontStyle: 'italic'
    },
    actionBtn: {
      background: 'transparent',
      border: '2px solid #6c757d',
      color: '#6c757d',
      padding: '12px 20px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      width: '100%',
      marginBottom: '10px',
      textDecoration: 'none',
      display: 'inline-block',
      textAlign: 'center',
      transition: 'all 0.3s ease'
    },
    viewCartBtn: {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      border: 'none',
      color: 'white',
      padding: '12px 20px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '500',
      width: '100%',
      textDecoration: 'none',
      display: 'inline-block',
      textAlign: 'center',
      transition: 'all 0.3s ease',
      boxShadow: '0 3px 10px rgba(102, 126, 234, 0.3)'
    },
    modalDialog: {
      maxWidth: '900px',
      margin: '30px auto'
    },
    modalContent: {
      border: 'none',
      borderRadius: '15px',
      boxShadow: '0 15px 35px rgba(0,0,0,0.1)',
      overflow: 'hidden'
    },
    closeButton: {
      backgroundColor: 'rgba(255,255,255,0.2)',
      border: 'none',
      borderRadius: '50%',
      color: 'white',
      fontSize: '18px',
      padding: '8px 12px',
      transition: 'all 0.3s ease'
    },
    badge: {
      backgroundColor: '#28a745',
      color: 'white',
      fontSize: '12px',
      padding: '4px 8px',
      borderRadius: '12px',
      marginLeft: '10px'
    }
  };

  return (
    <>
      <style>
        {`
        .custom-cart-modal .modal-dialog {
          max-width: 900px;
          margin: 30px auto;
        }
        
        .custom-cart-modal .modal-content {
          border: none;
          border-radius: 15px;
          box-shadow: 0 15px 35px rgba(0,0,0,0.1);
          overflow: hidden;
        }
        
        .product-img:hover {
          transform: scale(1.02);
        }
        
        .checkout-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(231, 76, 60, 0.4);
          background: linear-gradient(135deg, #c0392b 0%, #a93226 100%);
        }
        
        .action-btn:hover {
          background-color: #6c757d;
          color: white;
          transform: translateY(-1px);
        }
        
        .view-cart-btn:hover {
          transform: translateY(-1px);
          box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
        }
        
        .close-btn:hover {
          background-color: rgba(255,255,255,0.3);
          transform: scale(1.1);
        }
        
        .modal-backdrop {
          background-color: rgba(0,0,0,0.6);
          backdrop-filter: blur(5px);
        }
        
        @media (max-width: 768px) {
          .custom-cart-modal .modal-dialog {
            margin: 15px;
            max-width: calc(100% - 30px);
          }
          
          .product-info {
            text-align: center;
            margin-top: 20px;
          }
          
          .action-panel {
            margin-top: 30px;
          }
        }
        
        .quantity-badge {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          padding: 4px 12px;
          border-radius: 15px;
          font-size: 14px;
          font-weight: 600;
          margin-right: 10px;
        }
        `}
      </style>
      
      <Modal
        show={show}
        onHide={() => close()}
        className="custom-cart-modal"
        centered
        size="lg"
        aria-labelledby="cart-modal-title"
      >
        <Modal.Header style={styles.modalHeader} className="border-0">
          <Modal.Title id="cart-modal-title" style={styles.modalTitle}>
            <span style={styles.successIcon}>
              <i className="fa fa-check" aria-hidden="true"></i>
            </span>
            Item Added Successfully!
            <span style={styles.badge}>What's next?</span>
          </Modal.Title>
          <button
            type="button"
            onClick={() => close()}
            style={styles.closeButton}
            className="close-btn"
            aria-label="Close"
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </Modal.Header>
        
        <Modal.Body style={styles.modalBody}>
          <div className="container-fluid">
            <div className="row align-items-start">
              <div className="col-lg-8">
                <div className="row align-items-center">
                  <div className="col-md-5">
                    <img
                      className="product-img"
                      style={styles.productImage}
                      src={`/${latestAddedProduct.photo}`}
                      alt={latestAddedProduct.name}
                      onError={(e) => {
                        e.target.src = 'https://via.placeholder.com/300x300?text=Product+Image';
                      }}
                    />
                  </div>
                  <div className="col-md-7">
                    <div style={styles.productInfo} className="product-info">
                      <h3 style={styles.productName}>{latestAddedProduct.name}</h3>
                      <div style={styles.priceQuantity}>
                        <span className="quantity-badge">
                          {latestAddedProduct.quantity}x
                        </span>
                        <span style={styles.priceSpan}>
                          ৳{numberWithCommas(latestAddedProduct.price)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="col-lg-4">
                <div style={styles.actionPanel} className="action-panel">
                  <Link
                    to={ isAuthenticated ? "/checkout" : "/login"}
                    onClick={() => close()}
                    style={styles.checkoutBtn}
                    className="checkout-btn"
                  >
                    <i className="fa fa-credit-card" style={{marginRight: '8px'}}></i>
                    Proceed to Checkout
                  </Link>
                  
                  <div style={styles.subtotalSection}>
                    <div style={styles.subtotalLabel}>Order Subtotal</div>
                    <span style={styles.subtotalPrice}>
                      ৳{numberWithCommas(subtotalPrice)}
                    </span>
                    <div style={styles.cartInfo}>
                      Your cart contains {cartItems.length} {cartItems.length === 1 ? 'item' : 'items'}
                    </div>
                  </div>
                  
                  <Link
                    to="/viewPage"
                    onClick={close}
                    style={styles.viewCartBtn}
                    className="view-cart-btn"
                  >
                    <i className="fa fa-shopping-cart" style={{marginRight: '8px'}}></i>
                    View Full Cart
                  </Link>
                  
                  <Link
                    to="/"
                    onClick={close}
                    style={styles.actionBtn}
                    className="action-btn"
                  >
                    <i className="fa fa-arrow-left" style={{marginRight: '8px'}}></i>
                    Continue Shopping
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    show: state.globalState.showAddToCartModal,
    cartItems: state.cart,
    isAuthenticated: state.auth.token !== null,
  };
};

const mapDispatchToProps = {
  close: globalOperations.closeAddToCartModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddToCartModal);